import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";

import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import CustomTextField from "../../../../components/CustomTextField";

import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const Alert = styled(MuiAlert)(spacing);

const validationSchema = Yup.object().shape({
  userName: Yup.string()
    .required("Required")
    .matches(/^[a-zA-Z0-9,*._-]+$/, "Please enter valid username"),
});

const ChangeUserName = (props) => {
  const dispatch = useDispatch();
  const { isRenewSubmitting, updateUserName } = useUser();
  const { userId, refreshPage } = props;

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const {
    reset,
    handleSubmit,
    watch,
    resetField,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog, openDialog } = useDialog();

  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      const payload = {
        radUserId: userId,
        userName: data.userName,
      };
      await updateUserName(payload);
      dispatch(showSuccessSnackbar("Application password changed successfully!"));
      unSetDialog("change_user_name");
      if (typeof refreshPage === "function") {
        refreshPage();
      }
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("change_username")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationSchema.fields}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Save
            </Button>

            <Button variant="text" onClick={() => unSetDialog("change_user_name")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default ChangeUserName;
